"use client";

import ShareSection from "components/ShareSection";

export default function NewsShareSection({ newsName, detailUrl }) {
  return <ShareSection detailUrl={detailUrl} shareText={newsName || "News"} />;
}
